import {Component, OnInit, ViewChild} from '@angular/core';
import {HttpApiService} from "../../../../services/http-api.service";
import {UserService} from "../../../../services/user.service";
import {EndpointsService} from "../../../../services/endpoints.service";
import {ModalDirective} from "ngx-bootstrap";

@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html'
})
export class AccountStatusComponent implements OnInit {
  user: any = {};
  hasError: boolean;
  isUpdated: boolean;
  errorMessage: any;
  reasonForTermination: any;
  @ViewChild('modal') public modal: ModalDirective;

  constructor(private Api: HttpApiService,
              private userService: UserService,
              private endpoints: EndpointsService) {
  }

  ngOnInit() {
    this.Api.get(this.endpoints.getUserAccountStatusUrl(), true)
      .subscribe(user => {
        this.user = user;
      })
  }

  deleteAccount(reasonForTermination) {
    this.errorMessage = {};
    this.hasError = false;
    this.isUpdated = false;
    if (!reasonForTermination || !reasonForTermination.trim()) {
      this.errorMessage = "Please provider a reason.";
      this.hasError = true;
      return false;
    }
    this.Api.put(this.endpoints.getUserRequestTerminateAccountUrl() + "?reasonForTermination=" + reasonForTermination, {}, true)
      .subscribe(response => {
          this.isUpdated = true;
          this.user.pendingTermination = true;
          this.hideModal();
        },
        error => {
          this.hasError = true;
          this.errorMessage = JSON.parse(error._body).message;
        });
    return false;
  }

  public showModal(): void {
    this.modal.config.backdrop = false;
    this.modal.show();
  }

  public hideModal(): void {
    this.modal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/user/account-status/account-status.component.ts